import React from 'react';

const Home = () => {
    return (
        <div>გამარჯობა აფხაზეთო შენი</div>
    );
}

export default Home;